import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function TextAnalyzeSentiment() {
    const [results, setResults] = useState({ label: "", score: 0 });
    const [loading, setLoading] = useState(false);

    const controller = async () => {
        const text = document.getElementById("text").value;
        if (!text.trim()) {
            alert("Please enter some text to analyze.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch("https://ai-feats.nugenesisou.com/sentiment", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ text })
            });

            if (!response.ok) {
                throw new Error("Failed to analyze the text.");
            }

            const data = await response.json();
            setResults({
                label: data.label || "Unknown",
                score: data.score || 0
            });
        } catch (error) {
            console.error("Error analyzing text:", error);
            setResults({ label: "Error", score: 0 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>AI Detector</span>
                    </div>
                </section>

                <section class="security-hero">
                <div data-lavalamp=""></div>
                <div data-lavalamp=""></div>
                    <div class="content">
                        <div class="pad texts">
                            <h1><b>Free </b> AI Detector</h1>
                            <div class="subtitle">By NuGenesis</div>
                            <div class="text">
                            Add text to NuGenesis AI Detector and get a detailed report on how AI tools may have been used to create the content.
                            </div>
                        </div>
                    </div>
                </section>

                <section class="pad">
                    <div class="content">
                        <div class="text-par-container">
                            <p>Enter or paste text below and press "AI Detector"</p>
                            <textarea class="not-focus max-textarea" placeholder="Enter text here..." id="text"></textarea>

                            <div class="result min-result">
                                <div class="result-section">
                                    <div class="ai-detection">
                                        {results.score.toFixed(2)}
                                    </div>
                                    <div class="ai-detection-text-info" style={{ color: results.label === "POSITIVE" ? "green" : "red" }} >
                                        {results.label}
                                    </div>
                                </div>
                            </div>

                            <button class="submit-btn" onClick={controller}>
                                {loading ? "Loading..." : "Detector"}
                            </button>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
